// © Microsoft Corporation. All rights reserved.

import Popover, { PopoverProps } from "../popover/Popover";

import React from "react";
import { SocialClassNameContract } from "../../Social.classnames";
import { classNames } from "@microsoft/fast-web-utilities";
import {enums} from "../../utils/enums";
import { renderEmojiByType } from "../../utils/emojiIcons";

export interface MiniReactionBreakdownProps extends PopoverProps {
    managedClasses?: SocialClassNameContract;
    counts: Object;
}

export default class MiniReactionBreakdown extends React.Component<MiniReactionBreakdownProps> {

    render() {
        return (
            <Popover {...{...this.props, hideOnMobile: true, className: classNames(this.props.managedClasses.miniReactionBreakdownPopover, this.props.className)}}>
                <div className={classNames(this.props.managedClasses.miniReactionBreakdownContainer, "no-select")}>
                    {Object.keys(enums.reactionIconMap).filter(key => this.props.counts[key] > 0).map(key =>
                        <i key={key} className="cwt-icon cwt-count-icons" >
                            {renderEmojiByType(key)}
                            <span className="cwt-icon-label">{this.props.counts[key]}</span>
                        </i>
                    )}
                </div>
            </Popover>
        );
    }
}